/**
 * «پرسنل جدید» — تا ۴۵ روز بعد از تاریخِ استخدام (همان قاعدهٔ بک‌اند:
 * `employee_tags.is_new_hire`). بعدش خودبه‌خود برداشته می‌شود؛ هیچ‌جا ذخیره نمی‌شود.
 */
export const NEW_STAFF_DAYS = 45;

export function isNewStaff(hireDateISO, today = new Date()) {
  if (!hireDateISO) return false;
  const hd = new Date(String(hireDateISO).slice(0, 10) + "T00:00:00");
  if (Number.isNaN(hd.getTime())) return false;
  const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const days = Math.floor((t0 - hd) / 86400000);
  return days >= 0 && days < NEW_STAFF_DAYS;
}

/** از رکوردی که یا `is_new` (سرور) دارد یا `hire_date`. */
export function newStaffOf(rec) {
  if (!rec) return false;
  if (typeof rec.is_new === "boolean") return rec.is_new;
  return isNewStaff(rec.hire_date);
}
